import React from 'react';
import { Search } from 'lucide-react';

const SearchBar: React.FC = () => {
  return (
    <div className="hidden lg:flex flex-1 max-w-md">
      <div className="relative w-full">
        <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-500 stroke-[1.5]" />
        <input
          type="text"
          placeholder="Rechercher..."
          className="w-full pl-9 pr-4 py-2 text-sm font-medium bg-gray-100/80 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-accent/60 focus:border-transparent placeholder-gray-400"
        />
      </div>
    </div>
  );
};

export default SearchBar;